const us = () => {

    $(".rio-our-book").mousemove(function(event) {
        var offset = $(this).offset();
        x = event.pageX- offset.left;
        y = event.pageY- offset.top;
        bw = $(this).find(".background").width();
        bh = $(this).find(".background").height();
        $(this).find(".background").css({
            top: y - bh/2,
            left: x - bw/2
        })
    });
}
module.exports = us
